import React, { useCallback, useEffect } from 'react'
import { eventLogger } from 'services/eventLogger.service'
import { useTranslation } from 'react-i18next'
import smilingFace from 'assets/images/smiling-face.png'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'
import { StyledDownload as S } from './Download.styles'
import { LOGIN_METHOD_INSTRUCTION_LINK } from './constants'

export const Download: React.FC = () => {
  const { t } = useTranslation()

  useEffect(() => {
    eventLogger.logGettingAppShown()
  }, [])

  const handleContinue = useCallback(() => {
    window.location.href = LOGIN_METHOD_INSTRUCTION_LINK
  }, [])

  const handleClick = useCallback(() => {
    googleAnalyticsLogger.logDownloadButtonPressed()
    eventLogger.logDownloadClicked(handleContinue)
  }, [handleContinue])

  return (
    <S.Wrapper>
      <S.Title>{t('download.title')}</S.Title>
      <S.Image src={smilingFace} width={144} />
      <S.Subtitle>{t('download.subtitle')}</S.Subtitle>
      <S.Button
        type="button"
        data-deep-link={LOGIN_METHOD_INSTRUCTION_LINK}
        onClick={handleClick}
      >
        {t('download.buttonText')}
      </S.Button>
    </S.Wrapper>
  )
}
